import { render, staticRenderFns } from "./QuestionImageUpload.vue?vue&type=template&id=20a2a400&scoped=true&"
import script from "./QuestionImageUpload.vue?vue&type=script&lang=ts&"
export * from "./QuestionImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionImageUpload.vue?vue&type=style&index=0&id=20a2a400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a2a400",
  null
  
)

export default component.exports